import { useState } from 'react';
import HeroSection from './sections/HeroSection';
import CookieSection from './sections/CookieSection';
import ProductsSection from './sections/ProductsSection';
import PromoSection from './sections/PromoSection';
import FooterSection from './sections/FooterSection';
import CookieConsentSection from './sections/CookieConsentSection';
import CookiesPolicySection from './sections/CookiesPolicySection';

interface AdminDashboardProps {
  onLogout: () => void;
}

export default function AdminDashboard({ onLogout }: AdminDashboardProps) {
  const [activeSection, setActiveSection] = useState('hero');

  const sections = [
    { id: 'hero', name: 'Hero & Redes Sociais', icon: '🏠' },
    { id: 'cookie', name: 'Seção Bolachas', icon: '🍪' },
    { id: 'products', name: 'Produtos', icon: '📦' },
    { id: 'promo', name: 'Promoções (Instagram)', icon: '📸' },
    { id: 'footer', name: 'Rodapé', icon: '📄' },
    { id: 'cookie_consent', name: 'Barra de Cookies', icon: '🛡️' },
    { id: 'cookies_policy', name: 'Política de Cookies', icon: '📜' }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <h1 className="text-2xl font-bold text-gray-900">Painel Admin - Bolacha Mulata</h1>
            <button
              onClick={onLogout}
              className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg transition duration-200"
            >
              Sair
            </button>
          </div>
        </div>
      </header>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
          {/* Sidebar */}
          <div className="lg:col-span-1">
            <div className="bg-white rounded-lg shadow-sm p-4 sticky top-8">
              <h2 className="text-lg font-semibold text-gray-900 mb-4">Seções</h2>
              <nav className="space-y-2">
                {sections.map((section) => (
                  <button
                    key={section.id}
                    onClick={() => setActiveSection(section.id)}
                    className={`w-full text-left px-4 py-3 rounded-lg transition duration-200 flex items-center gap-3 ${
                      activeSection === section.id
                        ? 'bg-amber-100 text-amber-900 font-semibold'
                        : 'text-gray-700 hover:bg-gray-100'
                    }`}
                  >
                    <span className="text-xl">{section.icon}</span>
                    <span>{section.name}</span>
                  </button>
                ))}
              </nav>
            </div>
          </div>

          {/* Content */}
          <div className="lg:col-span-3">
            <div className="bg-white rounded-lg shadow-sm p-6">
              {activeSection === 'hero' && <HeroSection />}
              {activeSection === 'cookie' && <CookieSection />}
              {activeSection === 'products' && <ProductsSection />}
              {activeSection === 'promo' && <PromoSection />}
              {activeSection === 'footer' && <FooterSection />}
              {activeSection === 'cookie_consent' && <CookieConsentSection />}
              {activeSection === 'cookies_policy' && <CookiesPolicySection />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
